module.exports = __webpack_public_path__ + "static/img/hhky-logo.28406472.png";